import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NavTabsSkeleton = ({ isEventPage }) => {
  function Box({ children }) {
    return (
      <div
        style={{
          display: "block",
          lineHeight: 1,
          width: "80px",
          marginRight: "32px",
        }}
      >
        {children}
      </div>
    );
  }

  const navStyle = {
    height: "48px",
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    borderBottom: "1px solid #EDF1F6",
    maxWidth: !isEventPage ? 448 : 1216,
    margin: "0 16px",
  };

  return (
    <div style={navStyle}>
      <SkeletonTheme
        baseColor="#D8DBE0"
        highlightColor="#EDF1F6"
        borderRadius={"4px"}
      >
        <Skeleton wrapper={Box} inline={true} height={16} />
        <Skeleton wrapper={Box} inline={true} height={16} />
        <Skeleton wrapper={Box} inline={true} height={16} />
        <Skeleton wrapper={Box} inline={true} height={16} />
      </SkeletonTheme>
    </div>
  );
};

export default NavTabsSkeleton;
